<template>
  <div class="container">
    <div
      class="tui-goods-item"
      v-for="(product, index) in productList"
      :key="index"
    >
      <img :src="product.orderProductResponse.url" class="tui-goods-img" />
      <div class="tui-goods-center">
        <div>
          <div class="tui-goods-top">
            <div class="tui-goods-name">
              {{ product.orderProductResponse.name }}
            </div>
            <div class="order-operation">
              <!-- <span v-if="product.status == 1">待支付</span>
              <span v-if="product.status == 2">已取消</span>
              <span v-if="product.status == 3">已关闭</span>
              <span v-if="product.status == 4">待审核</span>
              <span v-if="product.status == 5">审核拒绝</span>
              <span v-if="product.status == 6">已冻结</span>
              <span v-if="product.status == 7">待发货</span>
              <span v-if="product.status == 8">已发货</span> -->
              <span v-if="product.status == 9">已签收</span>
              <!-- <span v-if="product.status == 10">已完成</span>
              <span v-if="product.status == 11">已结算</span>
              <span v-if="product.status == 12">待冲账</span>
              <span @click="routeToDetails(product)">订单详情</span> -->
            </div>
          </div>
          <div class="tui-goods-attr">
            <p>{{ product.orderProductResponse.subtitle }}</p>
            <!-- <p>支持7天无理由退货</p> -->
          </div>
        </div>
        <div class="tui-goods">
          <div class="tui-price-right">
            {{ product.orderProductResponse.point }}积分
          </div>
          <p class="tui-num-right">x{{ product.amount }}</p>
        </div>
      </div>
    </div>
    <div v-show="ifReturn">
      <van-form>
        <van-field v-model="returnForm.orderNo" label="订单编号" readonly />

        <!-- <van-field v-model="memberPhone" label="手机号" placeholder="请输入手机号" /> -->
        <!-- <van-field v-model="probleMsource" readonly clickable name="picker" label="客诉来源" placeholder="点击选择客诉来源" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar confirm-button-text="确定" :columns="probleMsourcelist" @cancel="showPicker = false" @confirm="onConfirm" />
        </van-popup>

        <van-field v-model="probleType" readonly clickable name="picker" label="客诉类型" placeholder="点击选择客诉类型" @click="show = true" />
        <van-popup v-model="show" position="bottom">
            <van-picker show-toolbar confirm-button-text="确定" :columns="probleTypelist" @cancel="show = false" @confirm="Confirm" />
        </van-popup> -->

        <!-- <van-field v-model="probleSpecific" readonly clickable name="picker" label="具体问题" placeholder="点击选择具体问题" @click="Picker = true" />
        <van-popup v-model="Picker" position="bottom">
            <van-picker show-toolbar confirm-button-text="确定" :columns="probleSpecificlist" @cancel="Picker = false" @confirm="firm" />
        </van-popup> -->


        <van-cell title="售后类型" required :value="serviceText" @click="popshow = true">
        </van-cell>

        <van-field
          v-model="returnForm.returnReason"
          label="问题描述"
          rows="2"
          type="textarea"
          required
          maxlength="100"
          placeholder="请输入问题描述"
        />
        <!--<span class="tips">自行寄回，邮费先垫付，收货后2日内返还</span>-->
        <van-field
          v-model="returnForm.addReason"
          rows="1"
          autosize
          label="问题凭证"
          readonly
          :required="serviceType!=1&&serviceType!=2&&serviceType!=4&&serviceType!=5"
        />
        <van-uploader
          v-model="fileList"
          :before-delete="beforeDelete"
          :before-read="beforeRead"
          :after-read="afterRead"
          :multiple="false"
          :max-count="1"
        />
        <span class="tips">仅支持一张凭证，图片大小不能超过2m</span>
        <van-button
          class="submitbtn"
          round
          block
          color="#2283E2"
          :loading="loading"
          @click="submitForm"
        >
          提交
        </van-button>

      </van-form>
    </div>
    <!-- 订单售后状态（1、用户发起初始状态未审核2、受理未通过3、受理通过、4用户填写快递单号、5、退换货商品已接收、6录入新物流单号已发货 -->
    <div v-show="!ifReturn">
      <van-steps :active="active" active-icon="success" active-color="#38f">
        <van-step>已发起</van-step>
        <van-step v-show="isReturnForm.status != 3 && isReturnForm.status != 2">受理结果</van-step>
        <!-- <van-step >
          <template v-slot:inactive-icon>
            <van-icon name="cross" color="red"/>
          </template>
          <template v-slot:active-icon>
            <van-icon name="cross" color="red"/>
          </template>
          <p style="color: red">审核未通过</p>
        </van-step> -->
        <van-step v-show="isReturnForm.status == 3 || isReturnForm.status == 2">
          <template v-slot:inactive-icon>
            <van-icon
              name="success"
              color="green"
              v-show="isReturnForm.status == 3"
            />
            <van-icon
              name="cross"
              color="red"
              v-show="isReturnForm.status == 2"
            />
          </template>

          <template v-slot:active-icon>
            <van-icon
              name="success"
              color="green"
              v-show="isReturnForm.status == 3"
            />
            <van-icon
              name="cross"
              color="red"
              v-show="isReturnForm.status == 2"
            />
          </template>
          <p style="color: red" v-show="isReturnForm.status == 2">审核未通过</p>

          <p
            style="color: green"
            v-show="isReturnForm.status == 3 && (isReturnForm.returnType == 1||isReturnForm.returnType >= 7)"
          >
            {{ isReturnForm.isSendBack === '1' ? '填写快递单号' : '审核通过' }}
          </p>
          <p
            style="color: green"
            v-show="isReturnForm.status == 3 && (isReturnForm.returnType == 2||isReturnForm.returnType == 4||isReturnForm.returnType == 5||isReturnForm.returnType == 6)"
          >
            审核通过
          </p>
        </van-step>
        <!-- <van-step>填写快递单号</van-step> -->
        <van-step>商品已接收</van-step>
        <van-step>新品已发货</van-step>
      </van-steps>
      <van-form v-if="isReturnForm.status >= 3 && (isReturnForm.returnType == 1 || isReturnForm.returnType >= 7) && isReturnForm.isSendBack==='1'">
        <div class="van-cell grey">亲爱的用户，请按商家备注的邮寄方式寄回您的产品，请务必正确填写退回物流信息，谢谢。</div>
        <div>
          <van-field
            v-model="expressNo"
            label="填写快递单号"
            rows="2"
            type="textarea"
            placeholder="请填写快递单号"
            :disabled="isReturnForm.status > 3"
          />
          <van-button
            class="submitbtn"
            round
            block
            color="#2283E2"
            v-show="isReturnForm.status == 3"
            :loading="loading"
            @click="submitForm(3)"
          >
            提交
          </van-button>
        </div>
      </van-form>
      <div class="van-cell grey" v-show="isReturnForm.status == 1">
        亲爱的用户，您的换货/补寄申请已收到，预计48小时内审核完毕，审核后请在7天内上传寄回单号。
      </div>
      <van-field
        v-model="isReturnForm.returnName"
        v-show="isReturnForm.returnName"
        rows="1"
        autosize
        label="寄回联系人"
        readonly
      />
      <van-field
        v-model="isReturnForm.returnPhone"
        v-show="isReturnForm.returnPhone"
        rows="1"
        autosize
        label="寄回联系电话"
        readonly
      />
      <van-field
        v-model="isReturnForm.returnAddress"
        v-show="isReturnForm.returnAddress"
        type="textarea"
        rows="2"
        autosize
        label="寄回地址"
        readonly
      />
      <van-field
        v-if="isReturnForm.freightPayTypeText"
        v-model="isReturnForm.freightPayTypeText"
        type="textarea"
        rows="1"
        autosize
        label="运费支付方式"
        readonly
      />
      <van-field
        v-model="isReturnForm.returnCreateTime"
        rows="1"
        autosize
        label="发起时间"
        readonly
      />
      <van-field
        v-model="isReturnForm.returnReason"
        label="问题描述"
        rows="2"
        type="textarea"
        readonly
      />
      <van-field
        v-model="isReturnForm.addReason"
        rows="1"
        label="问题凭证"
        readonly
      />
      <img :src="isReturnForm.photoUrl" alt="" class="returnimg" />
      <van-field
        v-model="isReturnForm.handlerTime"
        v-show="isReturnForm.handlerTime"
        rows="1"
        autosize
        label="审核时间"
        readonly
      />
      <van-field
        v-model="isReturnForm.handlerResult"
        v-show="isReturnForm.status==2"
        label="审核未通过原因"
        rows="2"
        type="textarea"
        readonly
      />

      <van-field
        v-model="isReturnForm.waybillNumber"
        v-show="isReturnForm.waybillNumber"
        center
        rows="1"
        autosize
        label="物流回执单号"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            v-if="isReturnForm.waybillNumber"
            @click="routeToLogistics(isReturnForm.waybillNumber)"
          >查询物流</van-button
          >
        </template>
      </van-field>
    </div>
    <van-popup
      v-model="popshow"
      position="bottom"
      :style="{ height: '40%' }"
      closeable
      round
    >
      <div class="radiobox">
        <van-radio-group
          v-model="serviceType"
          direction="horizontal"
          @change="toExorRe(serviceType)"
        >
          <div v-for="(item,index) in radioList" :key="index" class="radioitem">
            <van-radio :name="item.value">{{item.text}}</van-radio>
          </div>
        </van-radio-group>
        <van-button
          class="radiobtn"
          round
          block
          color="#2283E2"
          @click="popshow=false"
        >
          完成
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getOrderByNo, getByPrimaryKey, returnSave, uploadImg } from '@/api/api';

export default {
  data() {
    return {
      serviceType: '',
      serviceText: '',
      popshow: false,
      // probleSpecific: "",
      // Picker: false,
      // probleType: "",
      show: false,
      // memberPhone: "",
      // probleMsourcelist: ["在线客服", "电话中心", "留言", "QQ/微信", "小微"],
      // probleTypelist: ["订单问题", "产品问题", "库存问题"],
      // probleSpecificlist: ["产品货损", "产品功能", "发货延迟", "录错运单", "缺少配件", "错发丢失", "售后问题", "备货不足", "产品下市"],
      // saleList: {
      //     probleMsource: null,
      //     probleSpecific: null,
      //     probleType: null,
      // },
      // probleMsource: "",
      showPicker: false,
      productList: {},
      returnForm: {
        returnReason: '',
        orderNo: '',
        photoUrl: '',
      },
      fileList: [],
      imgUrlll: '',
      imgurl: false,
      ifReturn: null,
      active: null,
      isReturnForm: {
        freightPayType: ''
      },
      expressNo: '',
      loading: false,
      radioList: [
        {value: 4, text: '其他'},
        {value: 5, text: '物流问题'},
        {value: 6, text: '错发漏发'},
        {value: 8, text: '产品货损'},
        {value: 9, text: '质量问题'},
      ]
    };
  },
  mounted() {
    this.returnForm.orderNo = this.$route.query.orderNo;
    this.getPrimaryKey();
  },
  methods: {
    // 查询物流
    routeToLogistics(logisticsNo) {
      this.$router.push({
        path: '/orders/logistics',
        query: {
          logisticsNo: logisticsNo,
          // logisticsNo: "780098068058"
        },
      });
    },
    toExorRe(type) {
      this.returnForm.returnReason = '';
      this.fileList = [];
      let checkradio = this.radioList.filter(x => {
        if (x.value == type) {
          return x;
        }
      });
      this.returnForm.returnType = checkradio[0].value;
      this.isReturnForm.returnType = checkradio[0].value;
      this.serviceText = checkradio[0].text;
    },
    // 是否已售后
    async getPrimaryKey() {
      let params = {
        orderNo: this.$route.query.orderNo,
      };
      this.queryProduct();
      const res = await getByPrimaryKey(params);
      if (res.code == '0000' && res.data != null) {
        this.ifReturn = false;
        this.isReturnForm = res.data || {};
        this.expressNo = res.data.expressNo
        this.isReturnForm.freightPayTypeText = res.data.freightPayType == '1' ? '到付' : (res.data.freightPayType == '0' ? '现付' : '');
        if (res.data.status == 3) {
          this.active = 1;
        } else {
          if (res.data.status > 4) {
            this.active = res.data.status - 2;
          } else {
            this.active = res.data.status - 1;
          }
        }
      } else {
        this.ifReturn = true;
      }
    },
    async queryProduct() {
      let params = {
        orderNo: this.returnForm.orderNo,
      };
      const res = await getOrderByNo(params);

      this.productList = res.data.list;
      this.returnForm.returnCreatePhone = res.data.list[0].consigneePhone;
    },
    // onConfirm(probleMsource) {
    //     this.probleMsource = probleMsource;
    //     this.saleList.probleMsource = probleMsource == "在线客服" ? 1 :
    //         probleMsource == "电话中心" ? 2 :
    //         probleMsource == "留言" ? 3 :
    //         probleMsource == "QQ/微信" ? 4 : 5;
    //     this.showPicker = false;
    // },
    // Confirm(probleType) {
    //     this.probleType = probleType;
    //     this.saleList.probleType = probleType == "订单问题" ? 1 :
    //         probleType == "产品问题" ? 2 : 3;
    //     this.show = false;
    // },
    // firm(probleSpecific) {
    //     this.probleSpecific = probleSpecific;
    //     this.saleList.probleSpecific = probleSpecific == "产品货损" ? 1 :
    //         probleSpecific == "产品功能" ? 2 :
    //         probleSpecific == "发货延迟" ? 3 :
    //         probleSpecific == "录错运单" ? 4 :
    //         probleSpecific == "缺少配件" ? 5 :
    //         probleSpecific == "错发丢失" ? 6 :
    //         probleSpecific == "售后问题" ? 7 :
    //         probleSpecific == "备货不足" ? 8 : 9;
    //     this.Picker = false;
    // },
    beforeDelete(file) {
      let con = file.file.name;
      this.returnForm.photoUrl = '';
      this.imgurl = false;
      return true;
    },
    beforeRead(file) {
      const isLimit2M = 1024 * 1024 * 2; // 是否大于50M
      if (file.size > isLimit2M) {
        this.$toast('凭证大小不能超过2M！');
        return false;
      }
      return true;
    },
    async afterRead(file) {
      // 此时可以自行将文件上传至服务器
      var formData = new FormData();
      //可以通过append()方法来追加数据
      formData.append('file', file.file);
      const res = await uploadImg(formData);
      if (res.code == '0000') {
        // let con = this.fileList[this.fileList.length - 1].file.name;
        // this.$set(this.imgUrlll, con, res.data)
        this.returnForm.photoUrl = res.data;
        this.imgurl = true;
      }
    },
    async submitForm(type) {
      if (type == 3) {
        if (this.expressNo == '') {
          this.$toast('快递单号不能为空！');
          return;
        }
        this.returnForm = {
          ...this.isReturnForm,
          status: 4,
          expressNo: this.expressNo,
        };
      } else {
        if (!this.returnForm.returnType || this.returnForm.returnType == '') {
          this.$toast('售后类型不能为空！');
          return;
        }
        if (this.returnForm.orderNo == '') {
          this.$toast('订单编号不能为空！');
          return;
        }
        if (this.returnForm.returnReason == '') {
          this.$toast('问题描述不能为空！');
          return;
        }
        if (this.imgurl == false && this.serviceType != 1 && this.serviceType != 2 && this.serviceType != 4 && this.serviceType != 5) {
          this.$toast('请上传问题凭证');
          return;
        }
        this.returnForm.returnCreateId = parseInt(
          this.$cookies.get('memberId') || sessionStorage.getItem('memberId')
        );
      }
      // this.returnForm.returnCreatePhone = this.$cookies.get("memberPhone")||sessionStorage.getItem('memberPhone');
      this.returnForm.deptId = this.productList[0].deptId;
      this.returnForm.supplierName = this.productList[0].supplierName;
      this.loading = true;
      console.log(this.returnForm);
      let res = await returnSave(this.returnForm);
      if (res.code == '0000') {
        this.$toast('提交成功');
        location.reload();
        this.loading = false;
      } else {
        this.$toast(res.msg);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tui-goods-item {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #efefef;
}

.tui-goods-img {
  width: 180px;
  height: 180px;
  display: block;
  flex-shrink: 0;
  border-radius: 10px;
}

.tui-goods-center {
  flex: 1;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tui-goods {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.tui-goods-top {
  display: flex;
  justify-content: space-between;
}

.tui-goods-name {
  max-width: 310px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 28px;
  /* line-height: 32px; */
}

.tui-goods-attr {
  font-size: 26px;
  color: #999999;
  padding-top: 10px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: flex;
  justify-content: space-between;
}

.tui-price-right {
  color: #999999;
}

.tui-num-right {
  text-align: right;
  font-size: 24px;
  color: #888888;
}

.tui-color-red {
  color: #e41f19;
  padding-right: 30px;
}

.tui-goods-price {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  padding: 20px 30px;
}

.tui-size-24 {
  font-size: 24px;
  line-height: 24px;
}

.tui-order-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #fff;
  padding: 10px 30px 20px;
  box-sizing: border-box;
}

.tui-btn-ml {
  margin-left: 20px;
}

.container {
  background-color: #fff;
  padding-bottom: 150px;
  width: 750px;
}

.tui-order-header {
  height: 88px;
  background-color: $theme-color-blue;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;

  .tui-header-content {
    font-size: 30px;
    color: #ffffff;
    font-weight: 600;
    line-height: 88px;
  }

  .tui-goods-time {
    font-size: 24px;
    color: #fff;
    display: flex;
    align-items: center;

    .block {
      font-size: 24px;
      color: #ffffff;
    }
  }
}

.tui-img-bg {
  width: 100%;
  height: 160px;
}

.border-bottom {
  border-bottom: 1px solid #e8e8e8;
  width: 710px;
  margin-top: 34px;
}

.tui-flex-box1 {
  padding: 0 20px;
  height: 176px;
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eff5ff;
}

.tui-flex-box {
  padding: 0 20px;
  height: 176px;
  margin: 0 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
}

.tui-icon-img {
  width: 78px;
  height: 78px;
  flex-shrink: 0;
}

.tui-logistics {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px 0 20px;
  box-sizing: border-box;
}

.tui-logistics-text {
  font-size: 28px;
  color: #666666;
}

.tui-logistics-time {
  font-size: 24px;
  padding-top: 12px;
  color: #999999;
}

.tui-addr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  box-sizing: border-box;
}

.tui-addr-userinfo {
  font-size: 30px;
  line-height: 30px;
  color: #333333;
}

.tui-addr-text {
  font-size: 24px;
  line-height: 30px;
  padding-top: 16px;
  margin-right: 80px;
  color: #666666;
}

.tui-addr-tel {
  padding-left: 40px;
  font-size: 28px;
  color: #666666;
}

.tui-order-item {
  margin: 20px;
  border-radius: 10px;
  background-color: #ffffff;
}

.tui-goods-title {
  font-size: 28px;
  height: 99px;
  // border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  color: #666666;
  margin-left: 30px;
}

.tui-color-red {
  color: #e41f19;
  padding-right: 30px;
}

.tui-goods-price {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 24px;
}

.tui-size-24 {
  font-size: 24px;
  line-height: 24px;
}

.tui-price-large {
  font-size: 32px;
  line-height: 30px;
}

.tui-goods-info {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
}

.tui-price-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tui-size24 {
  padding-bottom: 24px;
  font-size: 24px;
  line-height: 24px;
  color: #888;
}

.tui-size32 {
  font-size: 32px;
  line-height: 32px;
  font-weight: 500;
}

.tui-pbtm20 {
  padding-bottom: 20px;
}

.tui-flex-shrink {
  flex-shrink: 0;
}

.tui-primary-color {
  color: #eb0909;
}

.tui-order-info {
  margin-top: 20px;
  background-color: #ffffff;
}

.tui-order-title {
  position: relative;
  font-size: 32px;
  line-height: 28px;
  padding: 30px 0;
  margin-left: 30px;
  border-bottom: 1px solid #e8e8e8;
  color: #999999;
}

.tui-order-content {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  font-size: 24px;
  line-height: 30px;
}

.tui-order-flex {
  display: flex;
  padding-top: 50px;
}

.tui-order-flex:first-child {
  padding-top: 0;
}

.tui-item-title {
  width: 132px;
  font-size: 28px;
  color: #333333;
}

.tui-item-content {
  font-size: 28px;
  color: #999999;
  margin-left: 20px;
}

.tui-safe-area {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  height: 148px;
  margin: 20px;
  background: #ffffff;
  border-radius: 14px;
  padding: 0 30px;

  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
}

.tui-tabbar {
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  font-size: 26px;
  z-index: 999;
  padding: 30px 0;
}

.tui-bottom {
  margin-right: 30px;
}

.margin-vanbottom {
  width: 180px;
  height: 58px;
  border: 2px solid #999999;
  border-radius: 29px;
}
.tips {
  color: #b7b6b6;
  padding: 0.26667rem 0.42667rem;
  line-height: 0.64rem;
  font-size: 0.3rem;
  display: block;
}
.van-uploader {
  padding: 0.26667rem 0.42667rem;
}
.returnimg {
  width: 80%;
  padding: 0.26667rem 0.42667rem;
}
.submitbtn {
  width: 80%;
  margin: 20px auto;
  position: fixed;
  bottom: 0;
  margin-left: 10%;
  z-index: 10;
}
.grey {
  color: #969799;
}
/deep/ .van-cell__title {
  -webkit-box-flex: 0;
  -webkit-flex: none;
  flex: none;
  box-sizing: border-box;
  width: 6.2em;
  margin-right: 0.32rem;
  color: #646566;
  text-align: left;
  word-wrap: break-word;
}
/deep/ .van-cell__value {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}
.radiobox {
  padding: 40px;
  margin-top: 20px;
}
.radioitem {
  display: flex;
  width: 100%;
  margin-bottom: 18px;
  font-size: 30px;
}
/deep/ .radiobtn {
  font-size: 30px;
  margin-top: 30px;
}
</style>
